import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'planos2array',
})
export class Planos2arrayPipe implements PipeTransform {
  transform(planos: any, args?: any[]) {
    let resposta: any = [];
    if (planos) {
      Object.keys(planos).forEach((chaveResposta) => {
        resposta.push(planos[chaveResposta]);
      });
    }
    return resposta;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/planos2array/planos2array.ts